module.exports = __webpack_public_path__ + "media/images/okra-offers/rewards-matters-01-e62b51b5e83e9f98b71035f62bfbe807.png";